// extracted by mini-css-extract-plugin
export var box = "_8o-1";
export var checked = "_8o-2";
export var descriptionSpacer = "_8o-9";
export var disabled = "_8o-3";
export var icon = "_8o-6";
export var input = "_8o-0";
export var labelSpacer = "_8o-8";
export var medium = "_8o-5";
export var small = "_8o-4";
export var text = "_8o-7";